import React from "react";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import OperatorNavbar from "../components/navbar/OperatorNavBar";

const OperatorLayout = () => (
  <DashboardLayout layout="/operator" Navbar={OperatorNavbar} />
);

export default OperatorLayout;
